import React, { FC } from "react"
import { graphql, Link, useStaticQuery } from "gatsby"

import { BookFragmentFragment, PostBookFooterNavQuery } from "@graphqlTypes"
import { generateConditionalClassName } from "@utils"

import IconButton, { ICON_BUTTON_VARIANTS } from "@components/IconButton/IconButton"
import { ICON_TYPES } from "@components/Icon/Icon.constants"

import { PostBookFooterNavDIV } from "./PostBookFooterNav.styles"
import { GatsbyImage } from "gatsby-plugin-image"
import { POST_BOOK_THEMES } from "../../PostBook"

const PostBookFooterNav: FC<{
  currentChapterIndex?: number | null,
  posts?: BookFragmentFragment["posts"],
  themeColor?: BookFragmentFragment["themeColor"],
}> = ({
  currentChapterIndex,
  posts,
  themeColor,
}) => {
    if (!posts || posts.length === 0) return null

    const prevBook = posts[(currentChapterIndex || 0) - 1]
    const nextBook = posts[(currentChapterIndex || 0) + 1]

    if (!prevBook && !nextBook) return null

    const hasSingle = !prevBook || !nextBook

    return (
      <PostBookFooterNavDIV className={generateConditionalClassName({
        "PostBookFooterNav": true,
        "has-single": hasSingle,
      })}>
        <div style={{ maxWidth: "var(--container-width)", width: "100%", margin: "0 auto" }}>
          <div className="grid">
            <div className={generateConditionalClassName({
              "PostBookFooterNav--cards": true,
              column: true,
              "column--2-12-XL": !hasSingle,
              "column--3-11-L": hasSingle,
              "column--4-10-XL": hasSingle,
            })}>
              {prevBook && (
                <Link
                  className={generateConditionalClassName({
                    "PostBookFooterNav--card": true,
                    "prev": true,
                  })}
                  to={prevBook.permalink || "/"}
                >
                  <IconButton
                    iconType={ICON_TYPES["arrow-left"]}
                    variant={ICON_BUTTON_VARIANTS.OUTLINE}
                  />
                  <div className="title">
                    <h6 className="type--mono-S">Previous Chapter</h6>
                    <h5 className="margin-bottom--0">{prevBook.title}</h5>
                  </div>
                  {prevBook.image?.imgixImage?.gatsbyImageData && (
                    <GatsbyImage
                      alt=""
                      image={prevBook.image?.imgixImage?.gatsbyImageData}
                      role="presentation"
                    />
                  )}
                </Link>
              )}
              {nextBook && (
                <Link
                  className={generateConditionalClassName({
                    "PostBookFooterNav--card": true,
                    "next": true,
                  })}
                  to={nextBook.permalink || "/"}
                >
                  <div className="title">
                    <h6 className="type--mono-S">Next Chapter</h6>
                    <h5 className="margin-bottom--0">{nextBook.title}</h5>
                  </div>
                  <IconButton
                    iconType={ICON_TYPES["arrow-right"]}
                    variant={ICON_BUTTON_VARIANTS.OUTLINE}
                  />
                  {nextBook.image?.imgixImage?.gatsbyImageData && (
                    <GatsbyImage
                      alt=""
                      image={nextBook.image?.imgixImage?.gatsbyImageData}
                      role="presentation"
                    />
                  )}
                </Link>
              )}
            </div>
          </div>
        </div>
      </PostBookFooterNavDIV>
    )
  }

export default PostBookFooterNav
